import classNames from 'classnames'
import React from 'react'
import Button from 'components/Button'
import logUtil from 'utils/log'
import Image from 'components/Image'
import getDefaultSwatchImageProductUtil from 'modules/product/utils/get-default-swatch-image'
import getSelectedColorOptionProductSelect from 'modules/variant/redux/selectors/get-selected-color-option'
import useSelector from 'hooks/use-selector'
import useDispatch from 'hooks/use-dispatch'
import updateSelectedColorOptionAction from 'modules/variant/redux/actions/update-selected-color-option'
import View from 'components/View'
import isInfluencerEnabledAppUtil from 'modules/app/utils/is-influencer-enabled'
import retryImageLoadUtil from 'containers/QuickShopProductSidebar/components/ColorSwatches/util/retry-image-load/index.js'

/**
 * @param isSelected
 * @param {ProductVariantCarouselInfo} productVariant
 * @param onClick
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarColorSwatchesItem ({
  isSelected,
  productVariant,
  onClick
}) {
  const dispatch = useDispatch()
  const iconUrl = productVariant?.option_icon_url
  const defaultIconUrl = getDefaultSwatchImageProductUtil(productVariant?.variant_image_url)
  const [shouldUseDefaultIconUrl, setShouldUseDefaultIconUrl] = React.useState(!iconUrl)
  const imageUrl = shouldUseDefaultIconUrl
    ? defaultIconUrl
    : iconUrl
  const [error, setError] = React.useState()

  // if it is selected && selectedColorIndex last value is null then update the selected color index
  const selectedColorOption = useSelector(getSelectedColorOptionProductSelect)

  const debugProps = {
    productVariant,
    defaultIconUrl,
    shouldUseDefaultIconUrl,
    error,
    selectedColorOption,
    imageUrl
  }
  logUtil('QuickShopProductSidebarColorSwatchesItem').debug('[start] debugProps=', debugProps)

  const handleClick = () => {
    onClick(productVariant)
  }

  const handleImageError = async (error) => {
    const success = await retryImageLoadUtil(imageUrl)

    if (success) {
      logUtil('QuickShopProductSidebarColorSwatchesItem#handleImageError').debug('Image loaded successfully')
      return
    }

    setError(error)
    setShouldUseDefaultIconUrl(true)
    logUtil('QuickShopProductSidebarColorSwatchesItem#handleImageError').error('Image load failed after retries', {
      error,
      failedUrl: imageUrl
    })
  }

  React.useEffect(() => {
    if (
      selectedColorOption === null &&
      isSelected
    ) {
      dispatch(
        updateSelectedColorOptionAction({
          selectedOption: productVariant?.color_option ?? productVariant?.option_value
        })
      )
    }
  }, [productVariant])

  const influencerInfo = productVariant?.influencer_info
  const influencerImageUrl = (
    isInfluencerEnabledAppUtil() &&
    !!influencerInfo
  )
    ? influencerInfo.option_image_url
    : null

  return (
    <Button
      key={productVariant.variant_id}
      className={
        classNames({
          'quick-shop-product-sidebar-color-swatches-list-item': true,
          'quick-shop-product-sidebar-color-swatches-list-item-with-influencer': !!influencerImageUrl,
          'quick-shop-product-sidebar-color-swatches-list-item_unavailable': productVariant?.available === false,
          'quick-shop-product-sidebar-color-swatches-list-item_selected': isSelected
        })
      }
      onClick={handleClick}
    >
      {
        !!influencerImageUrl && (
          <View
            className='quick-shop-product-sidebar-color-swatches-item-influencer-image-container'
          >
            <Image
              className='quick-shop-product-sidebar-color-swatches-item-influencer-image'
              src={influencerImageUrl}
            />
          </View>
        )
      }

      <Image
        className='quick-shop-product-sidebar-color-swatches-item-color'
        src={imageUrl}
        onError={handleImageError}
      />
    </Button>
  )
}
